const KEY = 'edge.postLoginPath'
const DEFAULT_DESTINATION = '/dashboard'

const AUTH_OR_GATE_PREFIXES = ['/password-reset']
const AUTH_OR_GATE_ROOTS = ['/login', '/register', '/verify-email', '/beta-locked', '/404']

type PathLike = string | { pathname: string; search?: string; hash?: string }

function isRememberable(path: string): boolean {
  // eslint-disable-next-line no-control-regex
  if (!path.startsWith('/') || path[1] === '/' || /[\\\u0000-\u001f]/.test(path)) return false
  const pathname = path.split(/[?#]/, 1)[0]
  if (pathname === '/' || pathname === '/billing' || pathname.startsWith('/billing/')) return false
  if (AUTH_OR_GATE_ROOTS.some((r) => pathname === r || pathname.startsWith(`${r}/`))) return false
  return !AUTH_OR_GATE_PREFIXES.some((p) => pathname.startsWith(p))
}

export function rememberPostLoginPath(target: PathLike): void {
  const path =
    typeof target === 'string'
      ? target
      : `${target.pathname}${target.search ?? ''}${target.hash ?? ''}`
  if (!isRememberable(path)) return
  try {
    sessionStorage.setItem(KEY, path)
  } catch {
    // storage unavailable — falls back to the default destination
  }
}

export function takePostLoginPath(): string | null {
  try {
    const path = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return path && isRememberable(path) ? path : null
  } catch {
    return null
  }
}

export function clearPostLoginPath(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}

export function postLoginDestination(): string {
  return takePostLoginPath() ?? DEFAULT_DESTINATION
}
